import { Reveal } from "../Reveal";

export const StockistCTA = () => {
  const scrollToConnect = () => {
    const el = document.querySelector("#connect");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="stockist-section"
      className="relative bg-cream text-forest py-24 sm:py-32 lg:py-36"
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <Reveal>
          <p className="overline text-earth mb-6">He Kaihoko · For Producers</p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-[1.1]">
            Would you like us to become a stockist for your rongoā products?
          </h2>
          <p className="mt-6 max-w-2xl mx-auto text-ink/60 font-light text-base sm:text-lg leading-relaxed">
            We are looking to partner with selected Māori and rongoā producers
            as we build our commercial foundation.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <button
            data-testid="stockist-cta-btn"
            onClick={scrollToConnect}
            className="mt-10 bg-forest text-cream px-9 py-4 text-sm tracking-wide hover:bg-gold hover:text-forest transition-colors duration-300"
          >
            Get in Touch
          </button>
        </Reveal>
      </div>
    </section>
  );
};
